import { Component } from "@/types"
import { Stack } from "@/ui/atoms/layout/Stack"
import { Title } from "@/ui/atoms/type/Title"
import { BodyText } from "@/ui/atoms/type/BodyText"
import { MarketingSection } from "@/ui/blocks/layout/MarketingSection"
import { cx } from "@/utils/cx"
import { Tile } from "./Tile"
import { tx } from "@/utils/tx"

export const COMPONENT_NAME = "cyberSecurity-section"

export const presets = {}

export interface Props extends Component {}

export function CyberSecuritySection({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <div className={cx(`bg-white`, className)} data-test={testId}>
      <MarketingSection removeXPadding>
        <Stack className="gap-y-12 lg:gap-x-12">
          <MarketingSection removeYPadding>
            {/* Header content */}
            <Stack className="lg:mx-auto w-full max-w-[720px] gap-8 lg:text-center">
              <Title size="xl" className="lg:text-[32px]">
                Cybersecurity has never mattered more
              </Title>
              <BodyText size="lg" className="lg:text-[20px] text-text-subtle font-light">
                The industry has seen a huge increase in demand for cybersecurity experts to help
                organisations face their modern adversaries. But as the landscape changes rapidly
                and evolves, there are hundreds of new courses out there for potential students to
                consider; it's impossible to know where to start.
              </BodyText>
            </Stack>
          </MarketingSection>
          {/* Tiles */}
          <div className="overflow-x-auto">
            <MarketingSection removeYPadding>
              <div className="flex gap-6">
                <Tile
                  title="8 in 10"
                  body="Organizations suffer breaches attributed to a lack of cybersecurity skills/awareness"
                  source="Fortune"
                  className={cx(
                    "col-span-3 gap-3",
                    "shrink-0 w-[280px]",
                    "lg:shrink lg:w-1/4",
                    "text-red-500",
                  )}
                />

                <Tile
                  title="33%"
                  body="Projected growth in cybersecurity job market over 10 years"
                  source="BLS"
                  className={cx(
                    "col-span-3 gap-3",
                    "shrink-0 w-[280px]",
                    "lg:shrink lg:w-1/4",
                    "text-teal-500",
                  )}
                />

                <Tile
                  title="$10.5t"
                  body="Projected cost of damages from cybercrime by 2025"
                  source="Cybersecurity Ventures"
                  className={cx(
                    "col-span-3 gap-3",
                    "shrink-0 w-[280px]",
                    "lg:shrink lg:w-1/4",
                    "text-orange-300",
                  )}
                />

                <Tile
                  title="3.4m"
                  body="Shortage of cybersecurity experts"
                  source="World Economic Forum"
                  className={cx(
                    "col-span-3 gap-3",
                    "shrink-0 w-[280px]",
                    "lg:shrink lg:w-1/4",
                    "text-purple-500",
                  )}
                />
                <div className="size-px shrink-0 lg:hidden" />
              </div>
            </MarketingSection>
          </div>
        </Stack>
      </MarketingSection>
    </div>
  )
}
